/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_ArchivalInputs */



/**
* | output |
* | --- |
* | "Archival" |
*
* @param {Tournament_ArchivalInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_archival = /** @type {((inputs?: Tournament_ArchivalInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_ArchivalInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Archive")
	if (locale === "es") return /** @type {LocalizedString} */ ("Archivo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Arquivo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Archivio")
	return /** @type {LocalizedString} */ ("Archival")
});